function join(t, a, s) {
    function format(m) {
        let f = new Intl.DateTimeFormat('en', m);
        return f.format(t);
    }
    return a.map(format).join(s);
}

let a = [{ day: 'numeric' }, { month: 'short' }, { year: 'numeric' }];

export function prettyDate(d) {
    var delta = Math.round((+new Date() - d) / 1000);
    var minute = 60,
        hour = minute * 60,
        day = hour * 24,
        week = day * 7;

    var fuzzy;

    if (delta < 30) {
        fuzzy = 'just now';
    } else if (delta < 2 * minute) {
        fuzzy = 'a minute ago'
    } else if (delta < 20 * minute) {
        fuzzy = Math.floor(delta / minute) + ' minutes ago';
    } else if (delta < hour) {
        fuzzy = Math.floor(delta / (10 * minute)) * 10 + ' minutes ago';
    } else if (Math.floor(delta / hour) == 1) {
        fuzzy = '1 hour ago'
    } else if (delta < day) {
        fuzzy = Math.floor(delta / hour) + ' hours ago';
    } else if (delta < day * 2) {
        fuzzy = 'yesterday';
    } else if (delta < week) {
        fuzzy = Math.floor(delta / day) + ' days ago';
    }
    else {
        fuzzy = join(d, a, ' ')
    }

    return fuzzy
}

const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];
const monthNamesShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];
export const dateToMonth = d => monthNamesShort[d.getMonth()]
export const dateToMonthYear = d => `${dateToMonth(d)} ${d.getFullYear()}`